var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketHistoryUniparIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3589_6351)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 20,
    fill: "#065E39"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.5732C27.6892 23.7869 28.3837 23.0112 29.0572 22.2142C29.236 22.0003 29.3202 22.0324 29.4833 22.2142C30.262 23.1075 30.7829 24.1452 31.1512 25.2685C31.5931 26.6165 31.7878 28.0019 31.793 29.4194C31.7983 31.2916 31.793 33.1638 31.793 35.0359C31.793 36.9669 32.9821 38.6679 34.7709 39.2991C37.4489 40.2459 40.3216 38.363 40.5794 35.4906C40.6004 35.2606 40.6109 35.0306 40.6109 34.7952C40.6109 30.6336 40.6162 26.4721 40.6057 22.3052C40.6057 22.0698 40.653 21.9949 40.9003 22.0003C41.8579 22.0163 42.8102 22.011 43.7677 22.0003C43.9519 22.0003 43.9992 22.0484 43.9992 22.2356C43.9939 26.6058 44.0097 30.9706 43.9887 35.3408C43.9729 38.7375 41.4685 41.8988 38.1592 42.7493C33.7871 43.8779 29.4202 41.0857 28.531 36.5925C28.4416 36.1485 28.3995 35.6939 28.3995 35.2392C28.4048 33.4098 28.41 31.5858 28.3995 29.7564C28.3995 28.4245 28.2574 27.1086 27.7366 25.8623C27.5524 25.4183 27.363 24.9636 27 24.6267C27 24.6106 27 24.5892 27 24.5732Z",
    fill: "#00FF3C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3589_6351",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3589_6351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3589_6351",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketHistoryUniparIcon);
export default __webpack_public_path__ + "static/media/ticket-history-unipar-icon.69e43f68a771262ecc5d369d6aa86961.svg";
export { ForwardRef as ReactComponent };